"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIST_TYPES = exports.DEFAULT_TEXT_FIELD = exports.DEFAULT_MARKS_FIELD = exports.DEFAULT_LIST_TYPES = exports.DEFAULT_LINK_ANNOTATION = exports.DEFAULT_DECORATORS = exports.DEFAULT_BLOCK_STYLES = exports.DECORATOR_UNDERLINE = exports.DECORATOR_STRONG = exports.DECORATOR_STRIKE = exports.DECORATOR_EMPHASIS = exports.DECORATOR_CODE = exports.DECORATORS = exports.BLOCK_STYLES = void 0;
var DEFAULT_LINK_ANNOTATION = {
  type: 'object',
  name: 'link',
  options: {
    editModal: 'popover'
  },
  fields: [{
    name: 'href',
    type: 'url',
    title: 'Url',
    validation: Rule => Rule.uri({
      scheme: ['http', 'https', 'tel', 'mailto'],
      allowRelative: true
    })
  }]
};
exports.DEFAULT_LINK_ANNOTATION = DEFAULT_LINK_ANNOTATION;
var DEFAULT_TEXT_FIELD = {
  type: 'text',
  name: 'text',
  title: 'Text'
};
exports.DEFAULT_TEXT_FIELD = DEFAULT_TEXT_FIELD;
var DEFAULT_MARKS_FIELD = {
  name: 'marks',
  type: 'array',
  of: [{
    type: 'string'
  }],
  title: 'Marks'
};
exports.DEFAULT_MARKS_FIELD = DEFAULT_MARKS_FIELD;
var LIST_TYPES = {
  bullet: {
    title: 'Bullet',
    value: 'bullet'
  },
  numbered: {
    title: 'Numbered',
    value: 'number'
  }
};
exports.LIST_TYPES = LIST_TYPES;
var DEFAULT_LIST_TYPES = [LIST_TYPES.bullet, LIST_TYPES.numbered];
exports.DEFAULT_LIST_TYPES = DEFAULT_LIST_TYPES;
var BLOCK_STYLES = {
  normal: {
    title: 'Normal',
    value: 'normal'
  },
  h1: {
    title: 'Heading 1',
    value: 'h1'
  },
  h2: {
    title: 'Heading 2',
    value: 'h2'
  },
  h3: {
    title: 'Heading 3',
    value: 'h3'
  },
  h4: {
    title: 'Heading 4',
    value: 'h4'
  },
  h5: {
    title: 'Heading 5',
    value: 'h5'
  },
  h6: {
    title: 'Heading 6',
    value: 'h6'
  },
  blockquote: {
    title: 'Quote',
    value: 'blockquote'
  }
};
exports.BLOCK_STYLES = BLOCK_STYLES;
var DEFAULT_BLOCK_STYLES = [BLOCK_STYLES.normal, BLOCK_STYLES.h1, BLOCK_STYLES.h2, BLOCK_STYLES.h3, BLOCK_STYLES.h4, BLOCK_STYLES.h5, BLOCK_STYLES.h6, BLOCK_STYLES.blockquote];
exports.DEFAULT_BLOCK_STYLES = DEFAULT_BLOCK_STYLES;
var DECORATOR_STRONG = {
  title: 'Strong',
  value: 'strong'
};
exports.DECORATOR_STRONG = DECORATOR_STRONG;
var DECORATOR_EMPHASIS = {
  title: 'Emphasis',
  value: 'em'
};
exports.DECORATOR_EMPHASIS = DECORATOR_EMPHASIS;
var DECORATOR_CODE = {
  title: 'Code',
  value: 'code'
};
exports.DECORATOR_CODE = DECORATOR_CODE;
var DECORATOR_UNDERLINE = {
  title: 'Underline',
  value: 'underline'
};
exports.DECORATOR_UNDERLINE = DECORATOR_UNDERLINE;
var DECORATOR_STRIKE = {
  title: 'Strike',
  value: 'strike-through'
};
exports.DECORATOR_STRIKE = DECORATOR_STRIKE;
var DECORATORS = {
  strong: DECORATOR_STRONG,
  em: DECORATOR_EMPHASIS,
  code: DECORATOR_CODE,
  underline: DECORATOR_UNDERLINE,
  strikeThrough: DECORATOR_STRIKE
};
exports.DECORATORS = DECORATORS;
var DEFAULT_DECORATORS = [DECORATORS.strong, DECORATORS.em, DECORATORS.code, DECORATORS.underline, DECORATORS.strikeThrough];
exports.DEFAULT_DECORATORS = DEFAULT_DECORATORS;